"use client";

import React from "react";
import { CreditCard, Wallet, Server } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * CreateWebshop — Section 2: Twint + Stripe USP
 * Drop-in für: src/pages/CreateWebshop/sections/Leistungen.tsx
 *
 * 3-Karten-Layout: die zentralen technischen Leistungen, mit Schweizer
 * Zahlungs-USP als Killer-Argument gegenüber Wix/Shopify.
 */

const items = [{
  icon: Wallet,
  title: "Twint Integration",
  description: "Die Schweizer Zahlungsmethode Nr. 1 — direkt im Checkout. Ihre Kunden zahlen mit der App, die jeder hat.",
  badge: "Schweizer USP",
  badgeColor: "bg-red-100 text-red-600"
}, {
  icon: CreditCard,
  title: "Stripe Zahlungen",
  description: "Kreditkarten, Apple Pay, Google Pay — weltweit. Sichere Zahlungsabwicklung nach PCI-Standard.",
  badge: "International",
  badgeColor: "bg-blue-100 text-blue-600"
}, {
  icon: Server,
  title: "WooCommerce Backend",
  description: "Das beliebteste Shop-System der Welt — auf WordPress. Tausende Erweiterungen, kein Vendor Lock-in.",
  badge: "Open Source",
  badgeColor: "bg-green-100 text-green-600"
}];
export default function Leistungen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-6xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Schweizer Standards. Weltweite Zahlungen.
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Alles, was ein Schweizer Webshop braucht — vorkonfiguriert.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((it, i) => <div key={i} className="bg-background border border-border rounded-2xl p-7 hover:shadow-xl hover:border-primary/40 transition-all duration-300 flex flex-col">
              <div className="flex items-start justify-between mb-5">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
                  <it.icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <span className={`text-[10px] font-semibold uppercase tracking-wider px-2 py-1 rounded-full ${it.badgeColor}`}>
                  {it.badge}
                </span>
              </div>
              <h3 className="text-xl font-bold text-foreground mb-2 tracking-tight">
                {it.title}
              </h3>
              <p className="text-base leading-relaxed text-muted-foreground">
                {it.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}